/**
 * Logs all actions and state changes in development mode.
 * This helps with debugging by showing:
 * - Action type and payload
 * - Previous state
 * - Next state
 */

import { ActionReducer } from '@ngrx/store';
import { AppState } from '../index';

export function logger(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state: any, action: { type: any; }) => {
    // console.group(`[NgRx] ${action.type}`);
    // console.log('Previous state:', state);
    // console.log('Action:', action);

    const nextState = reducer(state, action);

    // console.log('Next state:', nextState);
    // console.groupEnd();

    return nextState;
  };
}

